module.exports = __webpack_public_path__ + "img/header_bg1.1f6da177.png";